import './user-image.style.sass';
import template from './user-image.tpl.pug';

class UserImageController {
    $onChanges(changeObject) {
        if (changeObject.url) {
            this.url = changeObject.url.currentValue;
        }
        if (changeObject.color) {
            this.color = changeObject.color.currentValue;
        }
        if (changeObject.name || changeObject.email) {
            if (changeObject.name) {
                this.name = changeObject.name.currentValue;
            }
            if (changeObject.email) {
                this.email = changeObject.email.currentValue;
            }

            this.initials = this.getInitialsFromName(this.name) || this.getInitialsFromEmail(this.email) || null;
        }
    }

    update(url) {
        this.missing = !!url;
    }

    getInitialsFromName(name) {
        if (name && name.length > 0) {
            return name.split(' ')
                .filter((name) => name.length > 0 && /^[a-zA-Z]/g.test(name))
                .map((name) => name[0].toUpperCase())
                .join('')
                .substr(0, 2);
        }

        return null;
    }

    getInitialsFromEmail(email) {
        if (email && email.length > 0) {
            let name = email.replace(/@.+$/, '').replace(/[^a-zA-Z0-9]/, ' ');
            if (email !== name) {
                return this.getInitialsFromName(name);
            }
        }

        return null;
    }
}

export default {
    selector: 'dbAUserImage',
    template: template(),
    controller: UserImageController,
    bindings: {
        url: '<',
        color: '<',
        name: '<',
        email: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/user-image/user-image.cmpt.js